module.exports = __webpack_public_path__ + "img/shopee.4779a03a.png";